var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNecsAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "102.000000pt",
    height: "102.000000pt",
    viewBox: "0 0 102.000000 102.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,102.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386 1004 c-176 -43 -329 -197 -371 -375 -85 -362 235 -693 597 -618 244 51 425 290 405 534 -12 137 -65 244 -168 339 -126 117 -295 161 -463 120z m129 -214 c56 0 95 4 103 12 9 9 13 7 18 -5 3 -9 27 -30 54 -47 36 -23 48 -37 48 -55 0 -30 -14 -33 -21 -5 -4 15 -14 20 -41 20 -43 0 -41 4 -71 -137 l-22 -107 39 -134 c22 -73 38 -140 36 -149 -2 -9 -31 24 -71 81 -37 53 -69 96 -72 96 -2 0 -34 -43 -71 -95 -37 -52 -71 -92 -76 -89 -5 3 -6 13 -3 23 4 9 24 72 45 141 l39 125 -25 114 c-14 63 -27 118 -30 123 -3 4 -21 8 -41 8 -26 0 -36 -5 -40 -20 -8 -29 -23 -24 -23 8 1 22 11 33 55 60 30 18 55 38 55 45 0 8 3 8 12 -1 8 -8 46 -12 103 -12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 745 c0 -12 18 -15 105 -15 87 0 105 3 105 15 0 12 -18 15 -105 15 -87 0 -105 -3 -105 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365 740 c-3 -5 3 -10 14 -10 12 0 21 5 21 10 0 6 -6 10 -14 10 -8 0 -18 -4 -21 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 740 c0 -5 7 -10 16 -10 8 0 12 5 9 10 -3 6 -10 10 -16 10 -5 0 -9 -4 -9 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430 703 c0 -10 60 -100 75 -113 10 -9 22 1 54 46 23 32 41 61 41 66 0 4 -14 8 -31 8 -22 0 -32 -5 -36 -20 -3 -11 -12 -20 -19 -20 -8 0 -14 9 -14 20 0 16 -7 20 -35 20 -19 0 -35 -3 -35 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 608 c3 -18 12 -51 18 -73 l12 -40 18 27 c17 27 17 28 -14 73 -17 25 -33 45 -36 45 -3 0 -2 -15 2 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560 595 c-31 -45 -31 -47 -14 -72 17 -27 17 -27 25 -6 9 25 28 123 23 123 -2 0 -17 -20 -34 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 498 c-21 -30 -20 -51 3 -72 18 -16 20 -16 40 10 21 27 18 47 -13 73 -11 10 -17 8 -30 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455 418 c-16 -51 -42 -148 -39 -148 2 0 22 25 44 56 40 53 41 56 26 80 -18 27 -25 30 -31 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545 406 c-16 -24 -15 -26 21 -75 21 -28 40 -49 42 -46 6 6 -30 135 -39 141 -5 2 -15 -6 -24 -20z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNecsAccount);
export default __webpack_public_path__ + "static/media/necs_account.b921cc63f5b189c44f19679fd5600cd1.svg";
export { ForwardRef as ReactComponent };